export default () => ({
  draftPosts: [],
  draftDataPost: null
});